import { InternationalizedLabel } from '@/interfaces/InternationalizedLabel';

export class RuleFieldMessage {

  public fields: string[];
  public message: InternationalizedLabel;

  constructor(message: InternationalizedLabel, fields: string[]) {
    this.message = message;
    this.fields = fields;
  }
}
